import React from 'react';
import AppShell from '../../components/app-shell/app-shell';
import PublicShell from '../../components/app-shell/public-shell';
import PublicMarkdown from '../../components/markdown/public-markdown';
import BrushCalligraphyKitDescription from '../../components/landing-pages/brush-calligraphy-kit-description';
import markdown from './brush-calligraphy-kit-description.md';

export default function() {
  return (
    <AppShell seoTitle="Brush Calligraphy Kit Description" description="Our Brush Calligraphy Kit contains everything that you need to get started at a great price.">
      <PublicShell>
        <BrushCalligraphyKitDescription />
        <PublicMarkdown markdown={markdown} />
      </PublicShell>
    </AppShell>
  );
}
